<script setup lang="ts">
// hooks
import { useStrapiFooter } from '@api/strapi/footer/strapi-footer.hook'
// components
import FooterRoot from '@Widgets/Footers/FooterRoot.vue'

defineOptions({
  name: 'FooterLegacy',
})

const { refFooter } = await useStrapiFooter()
</script>

<template>
  <FooterRoot
    v-if="refFooter"
    :data="refFooter"
  />
</template>
